export default __webpack_public_path__ + "static/media/pine-wood.47802ff1.jpeg";